import React from 'react'

export const SecondHeading = (props) => {
  return (
    <>
        <h2 className='text-medium text-center'>{props.heading}</h2>
    </>
  )
}
